import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateEmailMarketingSchedule = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 710.37 509.13",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c,.d,.e,.f{fill:none;}.g{fill:#002f75;}.h{fill:#ebf3ff;}.i{fill:#ff584c;}.j{fill:#fff;}.k{fill:#9ec5ff;}.l{fill:#bd0f0f;}.m{fill:#dcebfe;}.n{fill:#146ef5;}.o{fill:#0c6734;}.d{stroke:#002f75;stroke-width:13px;}.d,.e,.f{stroke-linecap:round;stroke-miterlimit:10;}.e{stroke:#9ec5ff;stroke-width:10px;}.f{stroke:#ff584c;stroke-width:5px;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "h",
				cx: 363.69,
				cy: 253.26,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M229.7,27.85H95.46c-4.99,0-9.03,4.04-9.03,9.03V125.78c0,4.99,4.04,9.03,9.03,9.03h74c7.83,13.02,20.9,16.09,27.7,16.78,1.48,.15,2.35-1.63,1.31-2.7-4.79-4.96-6.87-9.86-7.61-14.08h38.84c4.99,0,9.03-4.04,9.03-9.03V36.89c0-4.99-4.04-9.03-9.03-9.03Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "m",
						d: "M106.54,79.45h112.07c1.22,0,2.21,.92,2.21,2.05h0c0,1.13-.99,2.05-2.21,2.05H106.54c-1.22,0-2.21-.92-2.21-2.05h0c0-1.13,.99-2.05,2.21-2.05Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "m",
						d: "M106.13,97.92h47.46c.99,0,1.8,.92,1.8,2.05h0c0,1.13-.81,2.05-1.8,2.05h-47.46c-.99,0-1.8-.92-1.8-2.05h0c0-1.13,.81-2.05,1.8-2.05Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "m",
						d: "M106.13,60.98h112.9c.99,0,1.8,.92,1.8,2.05h0c0,1.13-.81,2.05-1.8,2.05H106.13c-.99,0-1.8-.92-1.8-2.05h0c0-1.13,.81-2.05,1.8-2.05Z"
					})
				] })] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M701.34,111.29h-154.24c-4.99,0-9.03,4.04-9.03,9.03v58.89c0,4.99,4.04,9.03,9.03,9.03h34.46c-7.83,13.02-20.9,16.09-27.7,16.78-1.48,.15-2.35-1.63-1.31-2.7,4.79-4.96,6.87-9.86,7.61-14.08h141.18c4.99,0,9.03-4.04,9.03-9.03v-58.89c0-4.99-4.04-9.03-9.03-9.03Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "m",
					d: "M562.33,157.53h82.07c1.22,0,2.21,.92,2.21,2.05h0c0,1.13-.99,2.05-2.21,2.05h-82.07c-1.22,0-2.21-.92-2.21-2.05h0c0-1.13,.99-2.05,2.21-2.05Z"
				}), /* @__PURE__ */ _jsx("path", {
					className: "m",
					d: "M561.92,139.06h112.9c.99,0,1.8,.92,1.8,2.05h0c0,1.13-.81,2.05-1.8,2.05h-112.9c-.99,0-1.8-.92-1.8-2.05h0c0-1.13,.81-2.05,1.8-2.05Z"
				})] })] }),
				/* @__PURE__ */ _jsx("path", {
					className: "k",
					d: "M654.77,297.16h-81.29c-3.76,0-6.81,3.05-6.81,6.81v40.07c0,3.76,3.05,6.81,6.81,6.81h48.13c7.7,7.7,14.27,9.15,19.39,9.67,1.12,.11,1.77-1.23,.99-2.04-3.61-3.74-3.69-4.46-4.24-7.64h17.03c3.76,0,6.81-3.05,6.81-6.81v-40.07c0-3.76-3.05-6.81-6.81-6.81Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "g",
					d: "M528.23,439.27h-123.69c-4.33,0-7.85,3.51-7.85,7.85v36.19c0,4.33,3.51,7.85,7.85,7.85h85.47c8.87,8.87,16.44,10.54,22.34,11.15,1.29,.13,2.04-1.42,1.14-2.35-4.16-4.31-4.25-5.14-4.89-8.8h19.63c4.33,0,7.85-3.51,7.85-7.85v-36.19c0-4.33-3.51-7.85-7.85-7.85Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "k",
					d: "M53.96,112.6h91.3c4.22,0,7.65,3.42,7.65,7.65v45.01c0,4.22-3.42,7.65-7.65,7.65h-54.05c-8.65,8.65-16.02,10.27-21.77,10.86-1.25,.13-1.99-1.38-1.11-2.29,4.05-4.2,4.15-5.01,4.77-8.58h-19.12c-4.22,0-7.65-3.42-7.65-7.65v-45.01c0-4.22,3.42-7.65,7.65-7.65Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
					className: "n",
					d: "M177.63,295.7h-43.27c-.02-.08-.03-.16-.06-.23l-7.04-18.79c-.58-1.56-2.79-1.56-3.38,0l-7.04,18.79c-.03,.08-.04,.16-.06,.23h-43.27c-12.11,0-21.92,9.81-21.92,21.92h0c0,12.11,9.81,21.92,21.92,21.92h104.12c12.11,0,21.92-9.81,21.92-21.92h0c0-12.11-9.81-21.92-21.92-21.92Z"
				}), /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "j",
						cx: 125.57,
						cy: 317.62,
						r: 5.97
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "j",
						cx: 93.64,
						cy: 317.62,
						r: 5.97
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "j",
						cx: 157.51,
						cy: 317.62,
						r: 5.97
					})
				] })] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "o",
						d: "M231.82,469.72c-.02-.06-.04-.12-.06-.18,4.42-6.17,7.02-13.73,7.02-21.9,0-20.79-16.86-37.65-37.65-37.65s-37.65,16.86-37.65,37.65,16.86,37.65,37.65,37.65c8.12,0,15.63-2.57,21.78-6.94l9.73,5.74c1.31,.77,2.9-.43,2.51-1.9l-3.33-12.47Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "c",
						x: 178.01,
						y: 432.87,
						width: 47.56,
						height: 29.54,
						rx: 1.44,
						ry: 1.44
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "j",
						d: "M224.12,432.87h-44.67c-.8,0-1.44,.65-1.44,1.44v26.65c0,.8,.65,1.44,1.44,1.44h44.67c.8,0,1.44-.65,1.44-1.44v-26.65c0-.8-.65-1.44-1.44-1.44Zm-7.9,24.74c-.42,.48-1.15,.53-1.63,.11l-8.88-7.77-3.09,2.66c-.24,.2-.53,.29-.82,.27h-.03c-.29,.02-.58-.07-.82-.27l-3.09-2.66-8.88,7.77c-.48,.42-1.21,.37-1.63-.11-.42-.48-.37-1.21,.11-1.63l8.63-7.55-8.27-7.12c-.48-.42-.54-1.15-.12-1.63,.42-.48,1.15-.54,1.63-.12l12.46,10.72,12.46-10.72c.48-.42,1.21-.36,1.63,.12,.42,.48,.36,1.21-.12,1.63l-8.27,7.12,8.63,7.55c.48,.42,.53,1.15,.11,1.63Z"
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("polygon", {
					className: "l",
					points: "571.64 41.2 571.64 33.72 566.67 41.2 571.64 41.2"
				}), /* @__PURE__ */ _jsx("path", {
					className: "l",
					d: "M564.2,10.33c-15.47,0-28.01,12.54-28.01,28.01s12.54,28.01,28.01,28.01,28.01-12.54,28.01-28.01-12.54-28.01-28.01-28.01Zm-5.12,33.9c1.56,0,1.64-.6,1.72-1.01,.14-.71,.38-.74,1.39-.74v5.71h-12.24v-2.1l5.49-6.88c1.07-1.34,2.13-2.9,2.13-5.05,0-1.99-.71-4.23-3.03-4.23-.66,0-1.64,.41-1.64,1.15,0,.66,1.26,.76,1.26,2.43,0,1.2-.87,2.02-2.05,2.02-1.42,0-2.24-1.12-2.24-2.49,0-2.59,2.7-4.53,6.04-4.53,3.5,0,6.31,2.21,6.31,5.35,0,2.7-1.94,4.15-4.12,5.87-.85,.68-3.25,2.43-4.83,4.51h5.82Zm19.45-1.5h-2.57v2.57c0,1.12,.36,1.31,.87,1.37,.66,.08,.71,.33,.71,1.53h-7.48v-.71c0-.6,.35-.71,.71-.79,.55-.14,.87-.38,.87-1.39v-2.57h-6.83v-1.53l8.11-12.21h3.03v12.21h2.57v1.53Z"
				})] }),
				/* @__PURE__ */ _jsx("path", {
					className: "j",
					d: "M518.12,253.1c0,43.26-18.04,82.28-47.03,109.98-27.29,26.14-64.38,42.2-105.15,42.2s-77.82-16.01-105.15-42.15c-28.99-27.7-47.03-66.73-47.03-110.03,0-84.03,68.11-152.18,152.19-152.18s152.18,68.15,152.18,152.18Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "g",
						d: "M365.93,112.91c37.44,0,72.64,14.58,99.12,41.07,26.48,26.48,41.07,61.68,41.07,99.12,0,19.49-3.92,38.33-11.64,56.02-7.47,17.1-18.12,32.33-31.69,45.3-26.17,25.06-60.56,38.87-96.85,38.87s-70.68-13.79-96.86-38.83c-13.56-12.95-24.22-28.19-31.68-45.29-7.73-17.69-11.64-36.56-11.64-56.06,0-37.44,14.58-72.64,41.05-99.12,26.48-26.48,61.68-41.07,99.14-41.07m0-12c-84.08,0-152.19,68.15-152.19,152.18,0,43.3,18.04,82.33,47.03,110.03,27.33,26.14,64.38,42.15,105.15,42.15s77.86-16.06,105.15-42.2c28.99-27.7,47.03-66.73,47.03-109.99,0-84.03-68.15-152.18-152.18-152.18h0Z"
					}),
					/* @__PURE__ */ _jsx("line", {
						className: "d",
						x1: 365.93,
						y1: 124.16,
						x2: 365.93,
						y2: 110
					}),
					/* @__PURE__ */ _jsx("line", {
						className: "d",
						x1: 494.21,
						y1: 253.1,
						x2: 508.38,
						y2: 253.1
					}),
					/* @__PURE__ */ _jsx("line", {
						className: "d",
						x1: 225.23,
						y1: 253.1,
						x2: 239.39,
						y2: 253.1
					}),
					/* @__PURE__ */ _jsx("line", {
						className: "d",
						x1: 365.93,
						y1: 398.87,
						x2: 365.93,
						y2: 384.7
					})
				] }),
				/* @__PURE__ */ _jsx("line", {
					className: "e",
					x1: 299.72,
					y1: 209.66,
					x2: 392.29,
					y2: 270.51
				}),
				/* @__PURE__ */ _jsx("line", {
					className: "e",
					x1: 446.41,
					y1: 183.77,
					x2: 346.98,
					y2: 271.49
				}),
				/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("line", {
					className: "f",
					x1: 362.69,
					y1: 232.32,
					x2: 385.75,
					y2: 374.81
				}), /* @__PURE__ */ _jsx("circle", {
					className: "i",
					cx: 365.93,
					cy: 253.1,
					r: 8.71
				})] })
			]
		})
	]
});
export default SvgEmptyStateEmailMarketingSchedule;
